import { createSelector } from 'reselect';

export const selectChat = state => state.chat;

// Chat switching selector
export const selectIsSwitchingChat = state => state.chat.isSwitchingChat;

// Thinking messages selectors
export const selectHasThinkingMessages = state =>
  state.chat.messages.some(message => message.messageData?.isThinking === true);

// Bot list selectors
export const selectBotsList = state => state.chat.botsList;
export const selectSelectedBot = state => state.chat.selectedBot;
export const selectSelectedBotId = state => state.chat.selectedBot?.botId || null;

// Bot settings selectors
export const selectBotSettings = state => state.chat.botSettings;
export const selectBotSystemPrompt = state => state.chat.botSettings.systemPrompt;
export const selectBotTools = state => state.chat.botSettings.tools;
export const selectAvailableTools = state => state.chat.botSettings.availableTools;
export const selectBotTemperature = state => state.chat.botSettings.temperature;

// Bot settings loading selectors
export const selectBotSettingsLoading = createSelector([state => state.chat.isLoading], isLoading => ({
  getBotSystemPrompt: isLoading.getBotSystemPrompt,
  updateBotSystemPrompt: isLoading.updateBotSystemPrompt,
  getBotTools: isLoading.getBotTools,
  updateBotTools: isLoading.updateBotTools,
  getAvailableTools: isLoading.getAvailableTools,
  getBotsList: isLoading.getBotsList,
  getBotTemperature: isLoading.getBotTemperature,
  updateBotTemperature: isLoading.updateBotTemperature,
}));

// Bot settings error selectors
export const selectBotSettingsErrors = createSelector([state => state.chat.isError], isError => ({
  getBotSystemPrompt: isError.getBotSystemPrompt,
  updateBotSystemPrompt: isError.updateBotSystemPrompt,
  getBotTools: isError.getBotTools,
  updateBotTools: isError.updateBotTools,
  getAvailableTools: isError.getAvailableTools,
  getBotsList: isError.getBotsList,
  getBotTemperature: isError.getBotTemperature,
  updateBotTemperature: isError.updateBotTemperature,
}));

// Token usage selectors
export const selectTokenQuota = state => state.chat.tokenQuota;
export const selectTokenUsage = state => state.chat.tokenUsage;

export const selectTokenQuotaPercentage = createSelector([selectTokenQuota], tokenQuota => {
  const globalUsed = parseFloat(tokenQuota?.global_used) || 0;
  const globalLimit = parseFloat(tokenQuota?.global_limit) || 0;

  if (!globalLimit || globalLimit === 0) return 0;

  return Math.round((globalUsed / globalLimit) * 100);
});

export const selectTokenUsageLoading = createSelector([state => state.chat.isLoading], isLoading => ({
  getCompanyTokenQuota: isLoading.getCompanyTokenQuota,
  getCompanyTokenUsage: isLoading.getCompanyTokenUsage,
  pushCompanyTokenQuota: isLoading.pushCompanyTokenQuota,
}));

export const selectTokenUsageErrors = createSelector([state => state.chat.isError], isError => ({
  getCompanyTokenQuota: isError.getCompanyTokenQuota,
  getCompanyTokenUsage: isError.getCompanyTokenUsage,
  pushCompanyTokenQuota: isError.pushCompanyTokenQuota,
}));
